import { createRoot } from 'react-dom/client';
import 'normalize.css';
import 'assets/styles/index.scss';
import App from 'components/App';
import { SimulationProvider } from 'components/pages/Exploitation/SimulationContext';
import { ImportProvider } from 'providers/ImportStatus/importStatus.providers';
import { Amplify } from 'aws-amplify';

Amplify.configure({
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_APPSYNC_ENDPOINT,
      region: 'eu-west-3',
      defaultAuthMode: 'apiKey',
      apiKey: process.env.REACT_APP_APPSYNC_APIKEY
    }
  },
});

createRoot(document.getElementById('root')).render(
  <ImportProvider>
    <SimulationProvider>
      <App />
    </SimulationProvider>
  </ImportProvider>
);
